import type { Airline } from "../types";

export const parseAirlineCodes = (value?: string): string[] => {
  if (!value) return [];
  return [
    ...new Set(
      value
        .split(",")
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean)
    ),
  ];
};
export const parseAirlineCode = (value?: string): string | undefined => {
  if (!value) return;
  return value.trim().toUpperCase();
};

export const getSelectedAirlines = (airlineCodes: string[], eligibleAirlines: Airline[]): Airline[] =>
  eligibleAirlines.filter(({ code }) => airlineCodes.includes(code));

export const getSelectedAirlineCode = (airlineCodes: string[], eligibleAirlines: Airline[]): string | undefined =>
  getSelectedAirlines(airlineCodes, eligibleAirlines)[0]?.code;
